module.exports = __webpack_public_path__ + "img/ims.svg";